import React, { Component } from 'react';

import ConfirmationModal from '../ConfirmationModal/ConfirmationModal';

import './DirtyModal.css';

class DirtyModal extends Component {
    noClickHandler = () => {
        if (this.props.noClick) {
            this.props.noClick();
        }
    };

    yesClickHandler = () => {
        if (this.props.yesClick) {
            this.props.yesClick();
        } 
    };

    render() {
        return (
            <ConfirmationModal
                show={this.props.show}
                noClicked={this.noClickHandler}
                yesClicked={this.yesClickHandler}>
                <p>Looks like you have done some work on this page.</p>
                Are you sure you want to cancel?  All your work will be lost!
            </ConfirmationModal>
        );
    }
}

export default DirtyModal;
